import React,{ useState,useEffect } from 'react';
import {Card, CardBody, CardTitle, Col, Container, Row} from 'reactstrap';
import {useParams} from 'react-router-dom';
import ModelProduct from '../../../Models/Products';
import FeaturedCategories from "../../../shared/components/FeaturedCategories";
import JobsExecuted from "../../../shared/components/CronJobs/JobsExecuted";
import CronJobsTable from "../../../shared/components/CronJobs/CronJobsTable";
import PostsTable from "../../../shared/components/Posts/PostsTable";
import PostsCreated from "../../../shared/components/Posts/PostsCreated";

const Posts = () => {

    const { plink } = useParams();
    const mp = new ModelProduct();
    // const [pData,setData] = useState(null);
    const [isLoaded,setLoaded] = useState(false);

    useEffect(() => {

    },[]);

    return (
        <Container className="Home">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Posts</h3>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={3}>
                    <Card>
                        <CardBody>
                            <PostsCreated/>
                        </CardBody>
                    </Card>
                </Col>

            </Row>
            <Row>
                <PostsTable title={"Posts"}/>
            </Row>

        </Container>
    );
}

export default Posts;